export default __webpack_public_path__ + "static/media/icon_advantage_01.376d7508.png";